import { render, staticRenderFns } from "./citizenship_personal_details.vue?vue&type=template&id=739dcfac&"
import script from "./citizenship_personal_details.vue?vue&type=script&lang=js&"
export * from "./citizenship_personal_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports